import React from 'react'
import './ExcitingFeatures.css'
import FeatureItem from './FeatureItem/FeatureItem'

const ExcitingFeatures = () => {
    return (
        <section className="exciting-feauters-section-top">
            {/* === Exciting Features heading === */}
            <div className="exciting-feauters-section-heading-top">
                <div className="container">
                    <div className="exciting-feauters-heading-content">
                        <h1 className="invisible-title">Feauters</h1>
                        <h2 className="heading-title">Exciting Features</h2>
                        <div className="features-separetor"></div>
                        <p className="description">The game-changing app for the party and events industry! Increase exposure of your business through our platform and reach those clients that matter most to your business.</p>
                    </div>
                </div>
            </div>
            {/* === Business features tabs all content === */}
            <FeatureItem />
        </section>
    )
}

export default ExcitingFeatures
